import { Link } from "@tanstack/react-router"

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-10 border-b border-brew-border-soft bg-brew-bg">
      <div className="mx-auto max-w-brew-page px-brew-gutter-phone">
        <div className="flex min-h-[72px] items-center justify-center py-brew-6">
          <Link
            to="/"
            className="font-logo text-center text-[clamp(var(--font-size-brew-2xl),6vw,var(--font-size-brew-3xl))] font-normal leading-brew-tight tracking-widest text-brew-fg no-underline hover:text-brew-muted"
          >
            Brew Rides
          </Link>
        </div>
      </div>
    </header>
  )
}
